import { useNavigate } from 'react-router-dom'
import { RouteConstants } from '../../Constants/routeConstants'
import { logoNoText } from '../../commonservice'
import './AuthHeader.scss'

const AuthHeader = () => {
  const navigate = useNavigate()

  return (
    <div className="auth-header">
      <div className="auth-header__container">
        <div className="auth-header__content">
          <div className="auth-header__logo" onClick={() => navigate('/')}>
          <span className="brandLogo">
                LivingLegacy
                <span className="logo-dot">
                  <i className="fa fa-play-circle"></i>
                </span>
                me
              </span>
          </div>
          <div className="auth-header__signin">
            <i className="fa fa-user" onClick={() => navigate(RouteConstants.LOGIN)}></i>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AuthHeader 